(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naked-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-brand-ticker')) {
    customElements.define('nc-brand-ticker', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const button = this.querySelector('button');
        if (!button) return;
        button.hidden = false;
        this.setAttribute('data-ready', '');
        button.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naked-parallax-image"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-parallax')) {
    class NakedParallax extends HTMLElement {
      connectedCallback() {
        this.media = this.querySelector('.nc-parallax__media');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.frame = null;
        this.visible = false;
        this.onScroll = this.onScroll.bind(this);
        this.onPreferenceChange = this.onPreferenceChange.bind(this);
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.visible = entry.isIntersecting;
            if (this.visible) this.requestFrame();
          },
          { rootMargin: '25% 0px' }
        );
        this.observer.observe(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.reducedMotion.addEventListener('change', this.onPreferenceChange);
        this.mobile.addEventListener('change', this.onPreferenceChange);
        this.onPreferenceChange();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.reducedMotion.removeEventListener('change', this.onPreferenceChange);
        this.mobile.removeEventListener('change', this.onPreferenceChange);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      onPreferenceChange() {
        if (this.reducedMotion.matches || this.mobile.matches) {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = null;
          this.media.style.transform = '';
          this.media.style.filter = '';
          return;
        }
        this.requestFrame();
      }

      onScroll() {
        if (this.visible) this.requestFrame();
      }

      requestFrame() {
        if (this.frame || this.reducedMotion.matches || this.mobile.matches) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const rect = this.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / (viewportHeight + rect.height)));
        const speed = Number.parseFloat(getComputedStyle(this).getPropertyValue('--nc-parallax-speed')) || 0.35;
        const translateY = (progress - 0.5) * rect.height * speed;
        const scale = 1.08 - progress * 0.08;
        const blur = 3.5 * (1 - progress);
        this.media.style.transform = `translate3d(0, ${translateY.toFixed(2)}px, 0) scale(${scale.toFixed(4)})`;
        if (getComputedStyle(this).getPropertyValue('--nc-parallax-blur').trim() !== '0px') {
          this.media.style.filter = `blur(${blur.toFixed(2)}px)`;
        }
      }
    }

    customElements.define('nc-parallax', NakedParallax);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naked-support-category"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('naked-support-category')) {
    customElements.define('naked-support-category', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.openHash = () => {
          let hash; try { hash = decodeURIComponent(location.hash.slice(1)); } catch { return; }
          const aliases = (this.dataset.aliases || '').split(',').map(value => value.trim());
          if (hash && (hash === this.details.id || aliases.includes(hash) || this.querySelector(`[id="${CSS.escape(hash)}"]`))) {
            this.details.open = true;
            requestAnimationFrame(() => this.details.scrollIntoView({block:'start', behavior:'instant'}));
          }
        };
        this.editorOpen = event => { if (this.contains(event.target)) this.details.open = true; };
        window.addEventListener('hashchange', this.openHash);
        document.addEventListener('shopify:block:select', this.editorOpen);
        document.addEventListener('shopify:section:select', this.editorOpen);
        this.openHash();
      }
      disconnectedCallback() {
        window.removeEventListener('hashchange', this.openHash);
        document.removeEventListener('shopify:block:select', this.editorOpen);
        document.removeEventListener('shopify:section:select', this.editorOpen);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naked-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-brand-ticker')) {
    customElements.define('nc-brand-ticker', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const button = this.querySelector('button');
        if (!button) return;
        button.hidden = false;
        this.setAttribute('data-ready', '');
        button.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
